module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_1.a80d6fa2.png";